class Notification {
    constructor($notification) {
        this.$notification = $notification;
        this.notificationId = this.$notification.attr('data-notificationId');
        this.$acceptFriendButton = this.$notification.find('.js-friend-accept');
        this.$declineFriendButton = this.$notification.find('.js-friend-decline');
        this.$removeNotificationButton = this.$notification.find('.js-notification-seen');
        this.$notificationsEmpty = $('.js-notifications-empty');
        this.$actions = $notification.find('.js-actions');
        this.$feedback = $notification.find('.js-feedback');

        this.loading = false;
        this.accepting = false;
        this.declining = false;

        this.initEvents();
    }

    initEvents() {
        this.$acceptFriendButton.on('click', $.proxy(function(e) {
            e.preventDefault();
            this.accepting = true;
            this.handleRequest(e);
        }, this));

        this.$declineFriendButton.on('click', $.proxy(function(e) {
            e.preventDefault();
            this.declining = true;
            this.handleRequest(e);
        }, this));

        this.$removeNotificationButton.on('click', $.proxy(function(e) {
            e.preventDefault();
            this.removeNotification(e);
        }, this));
    }

    handleRequest(e) {
        if (this.loading) {
            return false;
        } else {
            this.loading = true;
        }

        const $target = $(e.currentTarget);
        const $loader = $target.find('.js-loader');

        const urls = {
            request: $target.attr('data-requestUrl'),
            complete: $target.attr('data-markAsCompleteUrl')
        };
        const i18n = {
            success: $target.attr('data-i18n-success'),
            error: $target.attr('data-i18n-error')
        };

        $loader.removeClass('u-hide');
        this.$feedback.addClass('u-hide');
        this.$acceptFriendButton.prop('disabled', true);
        this.$declineFriendButton.prop('disabled', true);

        if (this.accepting) {
            this.$acceptFriendButton.addClass('is-loading');
        } else {
            this.$declineFriendButton.addClass('is-loading');
        }

        $.when(
            $.get(urls.request, {
                notificationId: this.notificationId
            })
        ).then(() => {
            $.get(urls.complete, {
                notificationId: this.notificationId
            });
        }, function() {
            // accept/decline request failed, do nothing
        })
        .done(() => {
            this.$removeNotificationButton.removeClass('u-hide');
            this.$actions.hide();
            this.$feedback.text(i18n.success).removeClass('u-hide').show();

            if (this.accepting) {
                dataLayer.push({
                    'event': 'accept_friend_request',
                    'notificationId': this.notificationId,
                    'eventCategory': 'friends',
                    'eventAction': 'request_accept',
                    'eventLabel': "",
                });
            } else {
                dataLayer.push({
                    'event': 'decline_friend_request',
                    'notificationId': this.notificationId,
                    'eventCategory': 'friends',
                    'eventAction': 'request_decline',
                    'eventLabel': "",
                }); 
            }
        })
        .fail(() => {
            this.$feedback.text(i18n.error).removeClass('u-hide').show();
        }).always(() => {
            this.loading = false;
            this.accepting = false;
            this.declining = false;
            $loader.addClass('u-hide');
            this.$acceptFriendButton.prop('disabled', false).removeClass('is-loading');
            this.$declineFriendButton.prop('disabled', false).removeClass('is-loading');
        });
    }

    removeNotification(e) {
        const context = this;
        const $target = $(e.currentTarget);
        const markAsCompleteUrl = $target.attr('data-markAsCompleteUrl');
        const i18nError = $target.attr('data-i18n-error');

        $target.find('.js-loader').removeClass('u-hide');

        $.get(markAsCompleteUrl, {
            notificationId: this.notificationId
        }, function(res) {
            if (res.Error) {
                setTimeout(() => {
                    alert(i18nError);
                    $target.find('.js-loader').addClass('u-hide');
                }, 700);
            } else {
                setTimeout(() => {
                    // Show no-notification placeholder
                    if(!context.$notification.siblings('.js-notification').length) {
                        context.$notificationsEmpty.removeClass('u-hide');
                    }

                    // Decrease counter (hide when value reaches 0 or isNaN)
                    var $indicator = context.$notification.parents('body').find('.js-notifications-indicator');
                        var newIndicatorValue = Math.max(parseInt($indicator.text()) - 1, 0);
                    if (isNaN(newIndicatorValue) || newIndicatorValue === 0) {
                        $indicator.remove();
                    } else {
                        $indicator.text(newIndicatorValue);
                    }

                    // Remove notification
                    context.$notification.remove();
                }, 700);
            }
        }).fail(() => {
            setTimeout(() => {
                alert(i18nError);
                $target.find('.js-loader').addClass('u-hide');
            }, 700);
        });
    }
}

export default Notification;
